import { useLang } from "../i18n/LanguageContext";
import { Check, ArrowUpRight } from "lucide-react";

export const PricingTiers = () => {
  const { t } = useLang();

  return (
    <section
      id="tiers"
      data-testid="tiers-section"
      className="relative py-24 md:py-32 bg-[#f9f6f0]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 md:gap-12 mb-16 md:mb-20">
          <div className="col-span-12 md:col-span-4 flex items-start gap-3">
            <span className="editorial-divider mt-3" />
            <span className="overline" data-testid="tiers-overline">
              {t.tiers.overline}
            </span>
          </div>
          <div className="col-span-12 md:col-span-8">
            <h2
              data-testid="tiers-title"
              className="font-serif-display text-4xl md:text-5xl leading-[1.05] tracking-tight text-[#2c1e16] mb-5"
            >
              {t.tiers.title}
            </h2>
            <p className="text-base md:text-lg leading-relaxed text-[#2c1e16]/75 max-w-2xl">
              {t.tiers.sub}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto">
          {t.tiers.items.map((item, i) => (
            <div
              key={i}
              data-testid={`tier-card-${item.name.toLowerCase()}`}
              className={`group relative flex flex-col p-8 md:p-10 rounded-sm border transition-all duration-500 hover:-translate-y-1 ${
                item.featured
                  ? "bg-[#2c1e16] border-[#2c1e16] text-[#f9f6f0]"
                  : "bg-[#f2ebe1] border-[#e5d9c5] text-[#2c1e16] hover:border-[#a64b2a]/40"
              }`}
            >
              {item.featured && (
                <span className="absolute -top-3 left-8 px-3 py-1 bg-[#a64b2a] text-[#f9f6f0] text-[10px] font-mono-utility tracking-[0.25em] uppercase rounded-full">
                  · {item.tag} ·
                </span>
              )}

              <span
                className={`font-mono-utility text-[10px] tracking-[0.25em] uppercase mb-6 ${
                  item.featured ? "text-[#f2ebe1]/70" : "text-[#a64b2a]"
                }`}
              >
                {item.tag}
              </span>
              <h3 className="font-serif-display text-3xl md:text-4xl mb-1">
                {item.name}
              </h3>

              <div className="mt-6 mb-8 flex items-baseline gap-2">
                <span className="font-serif-display text-4xl md:text-5xl">
                  {item.price}
                </span>
                <span
                  className={`font-mono-utility text-xs tracking-wider ${
                    item.featured ? "text-[#f2ebe1]/70" : "text-[#5b664f]"
                  }`}
                >
                  {item.per}
                </span>
              </div>

              <ul className="space-y-3 mb-10 flex-1">
                {item.includes.map((inc, k) => (
                  <li key={k} className="flex items-start gap-3 text-sm md:text-base">
                    <Check
                      className={`w-4 h-4 mt-1 flex-shrink-0 ${
                        item.featured ? "text-[#a64b2a]" : "text-[#5b664f]"
                      }`}
                      strokeWidth={1.5}
                    />
                    <span
                      className={
                        item.featured ? "text-[#f2ebe1]/90" : "text-[#2c1e16]/80"
                      }
                    >
                      {inc}
                    </span>
                  </li>
                ))}
              </ul>

              <a
                href="#boarding"
                data-testid={`tier-cta-${item.name.toLowerCase()}`}
                className={`inline-flex items-center justify-between px-5 py-4 rounded-full text-xs font-mono-utility tracking-[0.2em] uppercase transition-colors ${
                  item.featured
                    ? "bg-[#a64b2a] text-[#f9f6f0] hover:bg-[#f9f6f0] hover:text-[#2c1e16]"
                    : "border border-[#2c1e16]/30 text-[#2c1e16] hover:border-[#2c1e16] hover:bg-[#2c1e16] hover:text-[#f9f6f0]"
                }`}
              >
                {t.tiers.cta}
                <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
